import React, { useState } from 'react';

export default function SWOTSection({ initialData, onSave }) {
  const [data, setData] = useState(initialData || {
    strengths: '',
    weaknesses: '',
    opportunities: '',
    threats: '',
  });

  const handleChange = (field, value) => {
    setData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    if (onSave) {
      onSave(data);
    }
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Strengths */}
        <div>
          <label className="block text-sm font-semibold text-on-surface mb-2">
            💪 Strengths
          </label>
          <textarea
            value={data.strengths}
            onChange={(e) => handleChange('strengths', e.target.value)}
            onBlur={handleSave}
            placeholder="What does your club do well? List key strengths (one per line)..."
            className="w-full px-3 py-2 border border-outline rounded-lg focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary text-on-surface bg-surface resize-none"
            rows={5}
          />
          <p className="text-xs text-on-surface-variant mt-1">
            Internal positive factors
          </p>
        </div>

        {/* Weaknesses */}
        <div>
          <label className="block text-sm font-semibold text-on-surface mb-2">
            ⚠️ Weaknesses
          </label>
          <textarea
            value={data.weaknesses}
            onChange={(e) => handleChange('weaknesses', e.target.value)}
            onBlur={handleSave}
            placeholder="What areas need improvement? List key weaknesses (one per line)..."
            className="w-full px-3 py-2 border border-outline rounded-lg focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary text-on-surface bg-surface resize-none"
            rows={5}
          />
          <p className="text-xs text-on-surface-variant mt-1">
            Internal areas for development
          </p>
        </div>

        {/* Opportunities */}
        <div>
          <label className="block text-sm font-semibold text-on-surface mb-2">
            🚀 Opportunities
          </label>
          <textarea
            value={data.opportunities}
            onChange={(e) => handleChange('opportunities', e.target.value)}
            onBlur={handleSave}
            placeholder="What external opportunities exist? List opportunities (one per line)..."
            className="w-full px-3 py-2 border border-outline rounded-lg focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary text-on-surface bg-surface resize-none"
            rows={5}
          />
          <p className="text-xs text-on-surface-variant mt-1">
            External positive factors
          </p>
        </div>

        {/* Threats */}
        <div>
          <label className="block text-sm font-semibold text-on-surface mb-2">
            🛑 Threats
          </label>
          <textarea
            value={data.threats}
            onChange={(e) => handleChange('threats', e.target.value)}
            onBlur={handleSave}
            placeholder="What external threats exist? List potential threats (one per line)..."
            className="w-full px-3 py-2 border border-outline rounded-lg focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary text-on-surface bg-surface resize-none"
            rows={5}
          />
          <p className="text-xs text-on-surface-variant mt-1">
            External risk factors
          </p>
        </div>
      </div>

      <button
        onClick={handleSave}
        className="btn-primary text-sm px-4 py-2"
      >
        Save SWOT Analysis
      </button>
    </div>
  );
}
